module.exports = __webpack_public_path__ + "img/dorm-bg.35c354a0.jpg";